import compose from 'recompose/compose';
import getContext from 'recompose/getContext';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';

const LayoutContainer = compose(
  getContext(
    {
      toggleSidebar: PropTypes.func.isRequired,
    }
  )
)(Layout);

export default LayoutContainer;
